import { ValidateEmail, ValidatePhoneNumber } from "../../../../../Validation/Validation"
import AdobeTextField from "../../../../AdobeAriaLib/AdobeTextField"
import { UseFormRegister } from "react-hook-form"
import FormTextInputWrapper from "./FormTextInputWrapper"

interface IFormContactDetails {
    value: IContactDetails,
    onChange: Function
    register?: UseFormRegister<Record<string, any>>
    fieldPrefix?: string
}

interface IContactDetails {
    telephone: string
    mobile: string
    fax: string
    email: string
}

export default function FormContactDetails({ value, onChange, register, fieldPrefix }: IFormContactDetails) {
    const prefix = fieldPrefix ? `${fieldPrefix}.` : '';

    function handleChange(val: IContactDetails) {
        onChange(val)
    }

    if (register) {
        return (
            <div>
                <div className="form-address">
                    <FormTextInputWrapper
                        label="Telephone Number"
                        value={value.telephone}
                        onChange={(x: string) => handleChange({ ...value, telephone: x })}
                        required={false}
                        autocomplete="tel"
                        name="telephone"
                        inputType="tel"
                        className="cell"
                        validateRule={ValidatePhoneNumber}
                        validationError="Please enter valid phone number"
                        register={register(`${prefix}telephone` as any)}
                    />
                    <FormTextInputWrapper
                        label="Mobile Number"
                        value={value.mobile}
                        onChange={(x: string) => handleChange({ ...value, mobile: x })}
                        required={false}
                        autocomplete="tel"
                        name="mobile"
                        inputType="tel"
                        className="cell"
                        validateRule={ValidatePhoneNumber}
                        validationError="Please enter valid phone number"
                        register={register(`${prefix}mobile` as any)}
                    />
                    <FormTextInputWrapper
                        label="Fax"
                        value={value.fax}
                        onChange={(x: string) => handleChange({ ...value, fax: x })}
                        required={false}
                        autocomplete="tel"
                        name="fax"
                        inputType="tel"
                        className="cell"
                        register={register(`${prefix}fax` as any)}
                    />
                    <FormTextInputWrapper
                        label="Email"
                        value={value.email}
                        onChange={(x: string) => handleChange({ ...value, email: x })}
                        required={false}
                        autocomplete="email"
                        name="email"
                        className="cell"
                        validateRule={ValidateEmail}
                        validationError="Please enter valid email"
                        register={register(`${prefix}email` as any)}
                    />
                </div>
            </div>
        );
    }

    return (<>
        <div>
            <div className="form-address">
                <AdobeTextField
                    value={value.telephone}
                    onChangeText={(x: string) => handleChange({ ...value, telephone: x })}
                    label="Telephone Number"
                    visibleLabel={true}
                    className="cell"
                    required={false}
                    disabled={false}
                    EnterKeyPress={() => { }}
                    validateRule={ValidatePhoneNumber}
                    validationError="Please enter valid phone number"
                    autocomplete="tel"
                    name="phone"
                    type="tel"
                />
                <AdobeTextField
                    value={value.mobile}
                    onChangeText={(x: string) => handleChange({ ...value, mobile: x })}
                    label="Mobile Number"
                    visibleLabel={true}
                    className="cell"
                    required={false}
                    disabled={false}
                    EnterKeyPress={() => { }}
                    validateRule={ValidatePhoneNumber}
                    validationError="Please enter valid phone number"
                    autocomplete="tel"
                    name="phone"
                    type="tel"
                />
                <AdobeTextField
                    value={value.fax}
                    onChangeText={(x: string) => handleChange({ ...value, fax: x })}
                    label="Fax"
                    visibleLabel={true}
                    className="cell"
                    required={false}
                    disabled={false}
                    EnterKeyPress={() => { }}
                    autocomplete="tel"
                    name="phone"
                    type="tel"
                />
                <AdobeTextField
                    value={value.email}
                    onChangeText={(x: string) => handleChange({ ...value, email: x })}
                    label="Email"
                    visibleLabel={true}
                    className="cell"
                    required={false}
                    disabled={false}
                    EnterKeyPress={() => { }}
                    validateRule={ValidateEmail}
                    validationError="Please enter valid email"
                    autocomplete="email"
                    name="email"
                />
            </div>
        </div>
    </>)
}